import React from 'react'
import PropTypes from 'prop-types'
import 'font-awesome/css/font-awesome.css'

const DomainEntry = (props) => {
	const statusClass = "fa fa-circle fa-lg " + (props.statusOk ? "statusOk" : "statusFail")

  const editIcon = props.editable ? 'fa fa-check-square-o fa-lg' : 'fa fa-pencil-square-o fa-lg'

  const editDomain = (evt) => {
    evt.preventDefault()
    props.toggleDomainEdit(props.name)
  }
	
	return (
		<div className="DomainEntry">
			<span className="Status">
				<i className={statusClass}/>
			</span>
			<span className="Name">{props.name}</span>
      <span className="DomainEdit i-btn" onClick={editDomain}>
				<i className={editIcon}/>
			</span>
		</div>
	)
}

DomainEntry.propTypes = {
	name: PropTypes.string.isRequired,
	statusOk: PropTypes.bool.isRequired,
  editable: PropTypes.bool.isRequired,
  toggleDomainEdit: PropTypes.func.isRequired,
}

export default DomainEntry



// WEBPACK FOOTER //
// ./src/components/ResultTable/DomainEntry.js